export type TwcSiteTrait = {
	name: string;
	value: unknown;
};

export type TwcSignupTouch = 'lowTouch' | 'highTouch' | null;

const touchByTraitName: Readonly<Record<string, Exclude<TwcSignupTouch, null>>> = {
	is_high_touch_twc_signup: 'highTouch',
	mock_is_high_touch_twc_signup: 'highTouch',
	is_low_touch_twc_signup: 'lowTouch',
	mock_is_low_touch_twc_signup: 'lowTouch',
};

const isTrueTraitValue = (value: unknown): boolean => value === true || value === 'true';

export const isHighOrLowTouchTwcSignup = (traits?: ReadonlyArray<TwcSiteTrait>): TwcSignupTouch => {
	for (const trait of traits ?? []) {
		const touch = touchByTraitName[trait.name];

		if (touch && isTrueTraitValue(trait.value)) {
			return touch;
		}
	}

	return null;
};
